import { Badge, Flex, Text, TooltipProps } from '@mantine/core';
import React, { PropsWithChildren } from 'react';
import { TooltipBox } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/TooltipBox.tsx';

interface Props {
	name?: string;
	count: number;
	allowTooltipSummary?: boolean;
	tooltipLabel?: TooltipProps['label'];
}

export const CollapsedListCount = ({
	name,
	count,
	allowTooltipSummary,
	tooltipLabel,
	children,
}: PropsWithChildren<Props>) => {
	const badgeCount = (
		<Badge bg="gray.4" c="dark.4" fw={400} size="sm">
			+{count}
		</Badge>
	);
	const badge = allowTooltipSummary ? (
		<TooltipBox label={tooltipLabel}>{badgeCount}</TooltipBox>
	) : (
		badgeCount
	);

	return (
		<Flex align="center" gap="0.25rem">
			{children ?? (
				<Text fw={400} truncate lineClamp={1} style={{ flex: 1 }}>
					{name}
				</Text>
			)}
			{count > 0 && badge}
		</Flex>
	);
};
